import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";
let variablePieModule;
try {
  variablePieModule = require("highcharts/modules/variable-pie");
  if (typeof variablePieModule === "function") {
    variablePieModule(Highcharts);
  } else if (variablePieModule?.default) {
    variablePieModule.default(Highcharts);
  }
} catch (err) {
  console.warn("Failed to load Highcharts", err);
}

const VariablePieChart = ({ data, options }) => {
  let formattedData = [];

  if (Array.isArray(data)) {
    formattedData = data;
  } else if (data?.labels && data?.datasets?.length) {
    const dataset = data.datasets[0];
    formattedData = data.labels.map((label, i) => ({
      name: label,
      y: dataset.data[i],
      z: dataset.data[i],
      color: dataset.backgroundColor?.[i],
      count: dataset.count[i],
    }));
  }

  const {
    title = "",
    labelFontSize = "16px",
    labelFontWeight = "600",
    valueFontSize = "16px",
    valueFontWeight = "500",
  } = options;

  const chartOptions = {
    accessibility: {
      enabled: false,
    },
    chart: {
      type: "variablepie",
      backgroundColor: "transparent",
    },
    title: {
      text: options?.title,
      style: {
        fontSize: "1.125rem",
        fontWeight: "bold",
      },
    },
    tooltip: {
      pointFormat:
        // "<b>{point.name}</b><br/>Value: {point.y}<br/>Radius: {point.z}",
        "<div><span>{point.label}</span><span>{point.count}</span><div>",
    },
    plotOptions: {
      variablepie: {
        allowPointSelect: true,
        cursor: "pointer",
        dataLabels: {
          enabled: true,
          format: "<span>{point.name}</span>: {point.y:.0f}%", // changed from .2f to .0f (Two decimal to no decimal(rounded))
          style: {
            textOutline: "none",
            fontSize: "1.125rem",
            fontWeight: "500",
          },
        },
      },
    },
    credits: {
      enabled: false,
    },
    series: [
      {
        minPointSize: 10,
        innerSize: "25%",
        zMin: 0,
        name: "Values",
        data: formattedData.map((d) => ({
          ...d,
          y: Math.round(d.y),
          z: Math.round(d.z),
        })),
      },
    ],
  };

  return (
    <HighchartsReact
      highcharts={Highcharts}
      options={chartOptions}
      containerProps={{ style: { width: "100%", height: "100%" } }}
    />
  );
};

export default VariablePieChart;
